import { useLocation } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { usesLocalFirebaseEmulators } from '@/lib/firebase';

type Reason = 'invalid' | 'invalid_length' | 'expired' | 'revoked' | string;

export function ErrorInvalidPage() {
  const location = useLocation();
  const state = (location.state as { reason?: Reason; error?: string } | null) ?? {};
  const reason = state.reason;
  const isDev = import.meta.env?.DEV;

  const mensajePorMotivo: Record<string, string> = {
    invalid_length: 'El enlace está incompleto (falta parte del token). Copia de nuevo el enlace completo desde la pantalla donde agregaste al candidato.',
    invalid: 'No se encontró ninguna invitación con este enlace. Asegúrate de copiar el enlace completo y de que el candidato se haya guardado correctamente.',
    expired: 'Este enlace ha caducado.',
    revoked: 'Este enlace ha sido revocado.',
  };
  const mensaje = reason ? mensajePorMotivo[reason] ?? 'Este enlace no es válido.' : 'Este enlace ha expirado, ha sido revocado o no es correcto. Contacta con Recursos Humanos si crees que es un error.';

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Enlace no válido</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-muted-foreground">{mensaje}</p>
          {isDev && (
            <div className="rounded-md bg-muted p-3 text-xs text-muted-foreground space-y-1">
              <p className="font-medium">Diagnóstico (solo en desarrollo)</p>
              <p>Motivo: {reason ?? '—'}</p>
              <p>Proyecto Firebase: {import.meta.env?.VITE_FIREBASE_PROJECT_ID ?? '—'}</p>
              <p>
                Emuladores Auth/Firestore:{' '}
                {usesLocalFirebaseEmulators ? 'Sí (local, `vite dev`)' : 'No (build de producción)'}
              </p>
              {state.error && <p>Error: {state.error}</p>}
              <p>Revisa la consola del navegador (F12) para más detalles.</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
